import styled from 'styled-components';

export const BottomCampaignCard = styled.div`
    display: flex;
    padding: 0 8px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    background: transparent;
`;

export const StatusChip = styled.div`
    display: inline-flex;
    padding: 0px;
    border-radius: 16px;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 12px;
    font-weight: 600;
    align-items: center;
    color: ${({ theme }) => theme?.colors?.theme?.sucess};
`;

export const InfoContainer = styled.div`
    display: flex;
    padding: var(--Sizes---sise-s, 8px) 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

export const TimeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
`;

export const TimeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const RewardsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
    width: 100%;
    max-width: 128px;
`;

export const IconWrapper = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

export const TextInfo = styled.span`
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 120%;
`;

export const StartDateTextInfo = styled(TextInfo)`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
`;

export const StatusDot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme?.colors?.theme?.sucess};
    margin-right: 4px;
    display: inline-block;
    align-self: center;
`;